import butter from "../../src/landingPage/utils/butter-client";
import { BlogPost } from "../../src/landingPage/views/Blog/BlogPost";
import Script from "next/script";
import { NextHead } from "../../src/landingPage/layouts/LayoutComponents/NextHead";
import { useNonce } from "../../../nemo/src/context/NonceContext";

const BlogPostPage = ({ post, currentUrl, resolvedUrl }) => {
  const { seo_title: title, meta_description: description, featured_image: image } = post;
  const { nonce } = useNonce();
  return (
    <>
      <NextHead
        currentPath={resolvedUrl}
        title={post.title}
        description={description}
        pageImageUrl={image}
      >
        <meta
          property="article:author"
          content={`${post?.author?.first_name} ${post?.author?.last_name}`}
        />
        <meta property="article:published_time" content={post?.published} />
        <meta property="article:modified_time" content={post?.updated} />
        {post.tags?.map(tag => (
          <meta key={tag} property="article:tag" content={tag} />
        ))}
        <Script
          type="application/ld+json"
          strategy="beforeInteractive"
          nonce={nonce}
          dangerouslySetInnerHTML={{
            _html: `
                {
                  "@context": "http://schema.org/",
                  "@type": "BlogPosting",
                  "author": {
                    "@type": "Person",
                    "name": "${`${post?.author?.first_name} ${post?.author?.last_name}`}"
                  },
                  "publisher": {
                    "@type": "Organization",
                    "name": "Demyst",
                  },
                  "headline": "${title}",
                  ${image !== null && `"image": "${image}"`},
                  "datePublished": "${post?.published}",
                  "dateModified": "${post?.updated}"
                }`,
          }}
        />
      </NextHead>
      <BlogPost post={post} currentUrl={currentUrl} />
    </>
  );
};

export const getServerSideProps = async context => {
  const { resolvedUrl } = context;
  const { blogId } = context.params;

  try {
    const {
      data: { data },
    } = await butter.post.retrieve(blogId);
    return {
      props: { post: data, currentUrl: `/blog/:blogId`, resolvedUrl, wrapper: "MarketingWrapper" },
    };
  } catch (e) {
    return {
      notFound: true,
    };
  }
};

export default BlogPostPage;
